export type StaticImageAsset = {
  id: string;
  url: string;
};

/**
 * Get the absolute URL of a static asset stored in the public directory
 */
export function getStaticAssetPath(
  assetNameRelativeToPublicDir: string,
  baseUrl: string = import.meta.url
) {
  if (import.meta.env.TEST && baseUrl === import.meta.url) {
    // if baseUrl is not explicitly provided, then tests assume it's a file:// location which will fail in new URL()
    // this block will be tree-shaken in prod build
    baseUrl = document.location.origin;
  }
  const origin = new URL(baseUrl).origin;
  return new URL(assetNameRelativeToPublicDir, origin).href;
}

export function filterStaticImageAssetsForIds(
  staticImageAssets: StaticImageAsset[],
  idsToFilter: string[]
): StaticImageAsset[] {
  return idsToFilter
    .map((idToFilter) =>
      staticImageAssets.find((asset) => asset.id.toLowerCase() === idToFilter.toLowerCase())
    )
    .filter(Boolean) as StaticImageAsset[];
}
